import React from "react";
import styles from "./NavBar.module.css";
import { AppBar, Toolbar, CssBaseline, Typography } from "@material-ui/core";
import { Link } from "react-router-dom";

const NavBar = ({ isTeacher, onLogout }) => (
    <AppBar position="static">
        <CssBaseline />
        <Toolbar className={styles.bar}>
            <Typography variant="p" className={styles.logo}>
                <svg width="50" height="50" viewBox="0 0 70 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M48.5833 17.6001H22.9167C20.8916 17.6001 19.25 19.2417 19.25 21.2668V46.9334C19.25 48.9585 20.8916 50.6001 22.9167 50.6001H48.5833C50.6084 50.6001 52.25 48.9585 52.25 46.9334V21.2668C52.25 19.2417 50.6084 17.6001 48.5833 17.6001Z" stroke="#cd05ff" stroke-width="3.5" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M19.25 29.2002H50.75" stroke="#cd05ff" stroke-width="3.5" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M20 40L50 40" stroke="#cd05ff" stroke-width="3.5" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M30 50V18" stroke="#cd05ff" stroke-width="3.5" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M41 49.8403V18" stroke="#cd05ff" stroke-width="3.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                MateRix
            </Typography>
            <div className={styles.navlinks}>
                <Link to="/" className={styles.link}>
                    <li>Home</li>
                </Link>
                <Link to="/matrix-properties" className={styles.link} id={styles.prop}>
                    <li>Matrix Properties</li>
                </Link>
                <Link to="/matrix-operations" className={styles.link}>
                    <li>Matrix Operations</li>
                </Link>
                <Link to="/exercises" className={styles.link}>
                    <li>Exercises</li>
                </Link>
                {isTeacher &&
                    <Link to="/add-exercises" className={styles.link}>
                        <li>Add Exercises</li>
                    </Link>
                }
                {isTeacher &&
                    (<a onClick={onLogout} >
                        <div className={styles.link} id={styles.login}>
                            Logout
                        </div>
                    </a>)
                }{!isTeacher && 
                    (<a href="https://uclapi.com/oauth/authorise?client_id=6293206230573205.0834319611020959&state=STATE">
                        <div className={styles.link} id={styles.login}>
                            Login
                        </div>
                    </a>)
                }
            </div>
        </Toolbar>
    </AppBar>
);

export default NavBar;